import React, { Component } from 'react'
import heroMockup from '../imgs/work-two/hero-2.gif';
import { Link } from "react-router-dom";


class WorkOne extends Component {
  render() {
    return (
      <section>
        <div className="hero-header">
          <div className="hero-header-img position-relative overflow-hidden text-center bg-two">
            <div class="container col">
              <div className="hero-back"><Link to="/work/1">←</Link></div>
              <div className="hero-next"><Link to="/work/3">→</Link></div>
            </div>
            <div class="animated fadeIn">
              <div className="col-10 col-md-8 col-lg-6 col-xl-5 mb-5 mx-auto">
                <h1 className="display-3 font-weight-bold mb-4">AI Ad <br class="d-block d-lg-none"/>Creatives</h1>
                <h2 className="font-weight-normal">Scaling digital display ads in Amazon Fresh and Whole Foods Market with AI.</h2>
                <br/>
                <p className="font-weight-bold">Amazon Confidential<br/>Email create@anmaree.com for access</p>
              </div>
              <div className="container col-12 px-5">
                <img className="mockup-img" src={heroMockup} alt="heroMockup" />
              </div>
            </div>
          </div>
        </div>
        <section className="py-8 py-lg-16 border-top">
          <div className="container px-5 px-lg-8">
            <div className="section-content">
              <div className="row">
                <div className="col-12 text-center">
                  <section className="my-5">
                    <div className="section-header">
                      <h4 className="display-4 mb-4">Amazon Confidential</h4>
                      <p>Email <b>create@anmaree.com</b> for access</p>
                    </div>
                  </section>
                </div>     
              </div>   
            </div>
          </div>
        </section>
      </section>
    )
  }
}

export default WorkOne